import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const WorkPortfolio = styled(motion(StyledFlexContainer))`
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	gap: 1.5rem;
	@media screen and (max-width: 300px) {
		gap: 2rem;
	}
`;

export default WorkPortfolio;
